import { useCallback, useEffect, useRef, useState } from 'react';
import Tabs from 'devextreme-react/tabs';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import { useAppSelector } from '../../../contexts/hooks';
import { GroupsConfigurationsWebPageResults } from '../../../utils/systemTypes';
import { Form, Label, Item as ControlItem } from 'devextreme-react/form';
import { Button, ScrollView, Tooltip } from 'devextreme-react';
import { newToast } from '../../../components';
import { RequiredRule, CustomRule } from 'devextreme-react/data-grid';
import { formatMessage } from 'devextreme/localization';
import { useApiConfigWebPageResult } from '../../../api/api.configurationWebPageResult';

export const ConfigGeneral = () => {
  const Prm_Conf = useAppSelector((x) => x.userInfo.Permissions?.Prm_Conf);
  const [currentGroup, setCurrentGroup] = useState<number>(1);
  const [EditItem, setEditItem] = useState<boolean>(true);
  const [data, setData] = useState<any>({});
  const [Configuracion, setConfiguracion] = useState<any[]>([]);
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const frmRef = useRef<Form>(null);
  const { getConfig, setConfig } = useApiConfigWebPageResult();

  useEffect(() => {
    getConfig().then((configuracion) => {
      setConfiguracion(configuracion);
      console.log('Configuracion:', configuracion);
      
      let formData = {};
      configuracion.forEach((item) => {
        console.log('Item:', item);
        formData[item.Cwr_Nombre] =
          item.Cwr_Control === 'dxSwitch'
            ? item.Cwr_Resultado === 'true' // Convertir string a booleano
            : item.Cwr_Resultado;
      });
      
      console.log('FormData:', formData);
      setData(formData); // Guarda el estado inicial para enviar los datos correctamente
      frmRef.current?.instance.updateData(formData);
    });
  }, []);

  const handleClicGroup = useCallback((e) => {
    setCurrentGroup(e.itemData.Value);
  }, []);

  const onTabsSelectionChanged = useCallback(
    async (args) => {
      const currentForm = frmRef.current?.instance;

      if (currentForm) {
        const validationResult = currentForm.validate();

        // Asegurar que hay reglas rotas
        if (validationResult?.brokenRules?.length && EditItem) {
          // Filtrar campos inválidos
          const invalidFields = validationResult.brokenRules.filter((rule) => {
            const fieldName = rule.type; // Obtener el nombre del campo directamente
            return (
              rule.type === 'required' &&
              fieldName && // Verificar que el campo existe
              (data[fieldName] === undefined || data[fieldName] === null || data[fieldName] === '')
            );
          });

          // Mostrar mensaje solo si hay campos realmente inválidos
          if (invalidFields.length > 0) {
            newToast('WARNING', 'Hay campos obligatorios pendientes por llenar', 5);
            return;
          }
        }
      }

      if (typeof args.value === 'number') {
        setSelectedTab(args.value);
      }
    },
    [frmRef, EditItem, data]
  );

  const handleEditClick = useCallback(() => {
    if (!Prm_Conf) {
      newToast('WARNING', 'No cuenta con permisos para editar la configuración', 5);
      setEditItem(true);
      return;
    }
    setEditItem(false);
  }, []);

  const handleSaveClick = useCallback(() => {
    if (frmRef.current) {
      if (frmRef.current?.instance.validate().isValid) {
        setConfig(data);
      } else {
        newToast('WARNING', 'Ingrese todos los datos requeridos', 5);
      }
    }
    setEditItem(true);
  }, [data]);

  function screenByWidth(width) {
    return width < 720 ? 'sm' : 'md';
  }
  return (
      <ScrollView className='view-wrapper-scroll' height={'100%'}>
        <Toolbar className='toolbar-common'>
          <Item location='before'>
            <span className='toolbar-header'>Configuración general</span>
          </Item>
          <Item location='before' widget='dxTabs'>
            <Tabs defaultSelectedIndex={0} dataSource={GroupsConfigurationsWebPageResults} width={'auto'} onItemClick={handleClicGroup} onOptionChanged={onTabsSelectionChanged} scrollByContent showNavButtons={false}></Tabs>
          </Item>
          <Item location='after' locateInMenu='auto' widget='dxButton' showText='inMenu'>
            <Button id='toolBarEdit' text={formatMessage('toolBarEdit')} stylingMode='outlined' icon='edit' type='default' onClick={handleEditClick} />
          </Item>
          <Item location='after' locateInMenu='auto' widget='dxButton' showText='inMenu'>
            <Button id='toolBarSave' text={formatMessage('toolBarSave')} stylingMode='outlined' icon='save' type='default' onClick={handleSaveClick} />
          </Item>
        </Toolbar>
        <div className='formStyle'>
          <form>
            <Form formData={data} ref={frmRef} labelLocation='top' minColWidth={233} colCount='auto' screenByWidth={screenByWidth} colCountByScreen={{ sm: 1, md: 2 }}>
              {Configuracion.map((item) => {
                console.log('Item:', item);
                switch (item.Cwr_Control) {
                  case 'dxSwitch':
                    return (
                      <ControlItem
                        key={item.Cwr_Id}
                        editorType={item.Cwr_Control}
                        editorOptions={{
                          value: data[item.Cwr_Nombre] === true || data[item.Cwr_Nombre] === 'true', // Asegura que siempre sea booleano
                          onValueChanged: (e) => {
                            const newValue = e.value === 'true' ? true : e.value === 'false' ? false : e.value;
                            setData((prev) => {
                              const updatedData = { ...prev, [item.Cwr_Nombre]: newValue };
                              return updatedData;
                            });
                          },
                        }}
                        disabled={EditItem}
                        visible={item.Cwr_Grupo === currentGroup}
                        dataField={item.Cwr_Nombre}
                        helpText={item.Cwr_Descripcion ? item.Cwr_Descripcion : ''}>
                        <Label text={item.Cwr_Label?.toUpperCase()} />
                        <CustomRule validationCallback={(e) => typeof e.value === 'boolean'} message='El campo es obligatorio' />
                      </ControlItem>
                    );
                  case 'dxSelectBox':
                    return (
                      <ControlItem key={item.Cwr_Id} editorType={item.Cwr_Control} editorOptions={{ items: JSON.parse(item.Cwr_ControlListas), displayExpr: 'label', valueExpr: 'value' }} disabled={EditItem} visible={item.Cwr_Grupo === currentGroup} dataField={item.Cwr_Nombre} helpText={item.Cwr_Descripcion ? item.Cwr_Descripcion : ''}>
                        <Label text={item.Cwr_Label?.toUpperCase()} />
                        {item.Cwr_Requerido === true && <RequiredRule />}
                      </ControlItem>
                    );
                  case 'dxTagBox':
                    if (EditItem === true) {
                    }
                    return (
                      <ControlItem
                        key={item.Cwr_Id}
                        dataField={item.Cwr_Nombre}
                        editorType='dxTextBox'
                        editorOptions={{
                          mask: 'LLLL',
                          maskRules: { X: /^[SYMD]+$/i },
                          maskMessagge: 'Sólo se aceptan los caractere S,Y,M,D',
                        }}
                        disabled={EditItem}
                        visible={item.Cwr_Grupo === currentGroup}
                        helpText={item.Cwr_Descripcion ? item.Cwr_Descripcion : ''}>
                        <Label text={item.Cwr_Label?.toUpperCase()} />
                        {item.Cwr_Requerido === true && <RequiredRule />}
                      </ControlItem>
                    );
                  default:
                    return (
                      <ControlItem key={item.Cwr_Id} editorType={item.Cwr_Control} disabled={EditItem} visible={item.Cwr_Grupo === currentGroup} dataField={item.Cwr_Nombre} helpText={item.Cwr_Descripcion ? item.Cwr_Descripcion : ''}>
                        <Label text={item.Cwr_Label?.toUpperCase()} />
                        {item.Cwr_Requerido === true && <RequiredRule />}
                      </ControlItem>
                    );
                }
              })}
            </Form>
          </form>
        </div>
        <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarSave'}>
          {formatMessage('toolBarSave')}
        </Tooltip>
        <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarEdit'}>
          {formatMessage('toolBarEdit')}
        </Tooltip>
      
      </ScrollView>
  );
};
